import pcc from "../assets/associates/pcclogo.png"

const carousel = document.querySelector('.cards-carousel');
const associateDesc = document.querySelector('.associate__desc');
const incrementBtn = document.querySelector('.carousel__next');
const decrementBtn = document.querySelector('.carousel__prev');
let cards = carousel.querySelectorAll('.card-container');
let currentIndex = 0;
let moveCooldown = false;
let autoPlay;

setUpCarousel();

incrementBtn.addEventListener('click', () => {
  if (moveCooldown) {
    return
  }
  clearInterval(autoPlay);
  incrementCarousel();
  moveCooldown = true;
  setTimeout(() => {
    moveCooldown = false;
  }, 300)
})

decrementBtn.addEventListener('click', () => {
  if (moveCooldown) {
    return
  }
  clearInterval(autoPlay);
  decrementCarousel();
  moveCooldown = true;
  setTimeout(() => {
    moveCooldown = false;
  }, 300)
})

function setUpCarousel() {
  const after = [cards[0], cards[1]];
  carousel.insertBefore(cards[cards.length-1].cloneNode(true), carousel.children[0]);
  carousel.appendChild(after[0].cloneNode(true));
  carousel.appendChild(after[1].cloneNode(true));
  cards = carousel.querySelectorAll('.card-container');
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    card.classList.add('no-transition');
  }
  updateCarousel();
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    card.offsetHeight;
    card.classList.remove('no-transition');
  }
  autoPlay = setInterval(() => {
    incrementCarousel();
  }, 10000);
}

function incrementCarousel() {
  currentIndex++;
  if (currentIndex >= 7) {
    setIndex(0);
    currentIndex++
  }
  updateCarousel();
}

function decrementCarousel() {
  currentIndex--;
  if (currentIndex < 0) {
    setIndex(6);
    currentIndex--;
  }
  updateCarousel();
}

function setIndex(index) {
  currentIndex = index;
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    card.classList.add('no-transition');
  }
  updateCarousel();
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    card.offsetHeight;
    card.classList.remove('no-transition');
  }
}

function updateCarousel() {
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    card.style.transform = `translateX(calc(-${(currentIndex)*100}%)`;
    if (window.innerWidth > 1000 && i !== currentIndex) {
      card.style.transform += `scale(0.8)`;
    }
    if (window.innerWidth < 428) {
      card.style.transform += `scale(0.84)`;
    }
    updateDesc();
  }
}

function updateDesc() {
  switch (currentIndex) {
    case 1 || 7:
      associateDesc.innerHTML = `
      <h2>Lilly Lewarne Architects</h2>
      <p>Lilly Lewarne Architects are a RIBA Chartered Practice located within a converted warehouse in Truro. They have over 25 years of experience in the county, a depth of local knowledge and strong reputation for excellent design. The Lilly Lewarne team are experienced in commercial, educational, healthcare, leisure, spa and hotel projects, as well as all aspects of residential architecture.</p>
      `
      break;

    case 2 || 8:
      associateDesc.innerHTML = `
      <h2>MBA Consulting</h2>
      <p>Formed and set up in 1990 under the name Michael Beardsall Associates and later rebranding to MBA Consulting, MBA have gained particular expertise in the areas of healthcare, major industrial development, infrastructure for housing development, appraisal of existing buildings, and insurance related work.</p>
      `
      break;

    case 3:
      associateDesc.innerHTML = `
      <h2>CSA Architects</h2>
      <p>CSA Architects is a design-led RIBA Chartered Practice based in Truro, Cornwall. Established in 1990 and with a longstanding reputation in Cornwall, they provide full architectural services on a range of projects including private homes, residential developments and commercial & leisure projects.</p>
      `
      break;

    case 4:
      associateDesc.innerHTML = `
      <h2>Andrew Mills Surveyors</h2>
      <p>Andrew Mills Surveyors is an independent practice of Chartered Building Surveyors with offices in Exmouth and Budleigh Salterton, near Exeter, East Devon. Established in 1977 the practice has experience of all types of commercial and residential properties and offers a full range of Building Surveying services throughout the South West.</p>
      `
      break;

    case 5:
      associateDesc.innerHTML = `
      <h2>A-Tec Design</h2>
      <p>A-Tec Design are a ‘Chartered Institute of Architectural Technologists’ registered practice, started by Daren Thomas in 1996, providing a professional architectural design service throughout Cornwall and the South of England.</p>
      `
      break;
    default:
      associateDesc.innerHTML = `
      <h2>P Chapman Construction</h2>
      <p>Based in the heart of Truro, P Chapman Construction are known for building unique beautiful luxury homes as well as renovating and extending existing properties. They build all over Cornwall utilising a team of multi-skilled people and excellent working relationships with architects, engineers, specialist desingers and many other services.</p>
      `
      break;
  }
  if (currentIndex == 0 || currentIndex == 6) {
  }
}

window.addEventListener('resize', () => {
  updateCarousel();
})